<main>
  <header>
    <div>
      <h1>{{ 'Exchange_Rates' | translateWF: 'Exchange Rates' }}</h1>
    </div>
    <div class="buttons">
      <p-button [label]="'Current_Rate' | translateWF: 'Current Rate'" (click)="getCurrentRate()" variant="outlined" icon="pi pi-refresh" />
      <span class="separator"></span>
      @if (!isReadOnly) {
        <p-button [label]="'Add_New' | translateWF: 'Add New'" (click)="showCreateFormToggle()" icon="pi pi-plus" />
      }
    </div>
  </header>
  <div class="content">
    <!-- Search Section -->
    <p-panel header="{{ 'Filters' | translateWF: 'Filters' }}" [toggleable]="false" data-variant="filter">
      <ng-template pTemplate="icons">
        <p-button [label]="'Clear' | translateWF: 'Clear'" (click)="clearSearch()" icon="pi pi-filter-slash" variant="outlined" size="small" />
        <p-button [label]="'Search' | translateWF: 'Search'" (click)="searchExchangeRates()" icon="pi pi-search" size="small" />
      </ng-template>
      <p-card data-variant="fields">
        <div class="form-box">
          <label for="searchFromDate">{{ 'Search_From_Date' | translateWF: 'From date' }}</label>
          <p-calendar [formControl]="searchFromDate" styleClass="w-full" [showIcon]="true" appendTo="body" />
        </div>
        <div class="form-box">
          <label for="searchToDate">{{ 'Search_To_Date' | translateWF: 'To date' }}</label>
          <p-calendar [formControl]="searchToDate" styleClass="w-full" [showIcon]="true" appendTo="body" />
        </div>
        <div class="form-box">
          <label for="searchCurrency">{{ 'Currency' | translateWF: 'Currency' }}</label>
          <p-dropdown [formControl]="searchCurrency" [options]="currencyOptions()" optionLabel="label" optionValue="value" styleClass="w-full" [disabled]="true" />
        </div>
      </p-card>
      <ng-template pTemplate="footer">
        <div class="text-surface-500 text-sm">
          {{ 'Exchange_Rate_Range_Hint' | translateWF: 'Leave both dates empty to list every rate on record.' }}
        </div>
      </ng-template>
    </p-panel>

    <!-- Create/Edit Form -->
    @if (showCreateForm()) {
      <div class="p-4 border border-gray-300 rounded">
        <div class="row-between-center mb-4">
          <h2>
            @if (editing()) {
              {{ 'Edit_Exchange_Rate' | translateWF: 'Edit Exchange Rate' }}
            } @else {
              {{ 'New_Exchange_Rate' | translateWF: 'New Exchange Rate' }}
            }
          </h2>
          <div class="buttons">
            <p-button
              class="mr-2"
              [label]="'Save' | translateWF: 'Save'"
              (click)="save()"
              [disabled]="buyRateToUSD.invalid || sellRateToUSD.invalid || effectiveDate.invalid || currency.invalid || source.invalid"
            />
            <p-button [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="cancel()" />
          </div>
        </div>

        <div class="grid-12">
          <div class="span-6-3">
            <div class="form-box">
              <label for="buyRateToUSD">{{ 'Buy_Rate' | translateWF: 'Buy rate (compra)' }} <small>· HNL / 1 USD</small> *</label>
              <p-inputNumber [formControl]="buyRateToUSD" styleClass="w-full" [minFractionDigits]="4" [maxFractionDigits]="rateDecimals" [min]="0.01" placeholder="24.7000" />
            </div>
          </div>
          <div class="span-6-3">
            <div class="form-box">
              <label for="sellRateToUSD">{{ 'Sell_Rate' | translateWF: 'Sell rate (venta)' }} <small>· HNL / 1 USD</small> *</label>
              <p-inputNumber [formControl]="sellRateToUSD" styleClass="w-full" [minFractionDigits]="4" [maxFractionDigits]="rateDecimals" [min]="0.01" placeholder="24.7500" />
            </div>
          </div>
          <div class="span-6-3">
            <div class="form-box">
              <label>{{ 'Average_Rate' | translateWF: 'Average (promedio)' }}</label>
              <span class="rate-readout">{{ averageRate() !== null ? (averageRate() | number: '1.4-10') : '—' }}</span>
            </div>
          </div>
          <div class="span-6-3">
            <div class="form-box">
              <label for="rateToUSD">{{ 'Rate_to_USD' | translateWF: 'Legacy rate' }} <small>· HNL / 1 USD</small></label>
              <p-inputNumber
                [formControl]="rateToUSD"
                styleClass="w-full"
                [minFractionDigits]="4"
                [maxFractionDigits]="rateDecimals"
                [min]="0.01"
                [readonly]="true"
                placeholder="24.7000"
              />
              <small class="text-surface-500">{{
                'Rate_to_USD_Hint'
                  | translateWF
                    : 'Legacy (= buy/compra); derived, kept
              for existing consumers.'
              }}</small>
            </div>
          </div>

          <div class="span-6-3">
            <div class="form-box">
              <label for="financialInstitution">{{ 'Financial_Institution' | translateWF: 'Financial institution' }}</label>
              <input pInputText [formControl]="financialInstitution" class="w-full" placeholder="Banco Central de Honduras" />
            </div>
          </div>
          <div class="span-6-3">
            <div class="form-box">
              <label for="effectiveDate">{{ 'Effective_Date' | translateWF: 'Effective Date' }} *</label>
              <p-calendar [formControl]="effectiveDate" styleClass="w-full" [showIcon]="true" />
            </div>
          </div>
          <div class="span-6-3">
            <div class="form-box">
              <label for="currency">{{ 'Currency' | translateWF: 'Currency' }} *</label>
              <p-dropdown [formControl]="currency" [options]="currencyOptions()" optionLabel="label" optionValue="value" styleClass="w-full" [disabled]="true" />
            </div>
          </div>
          <div class="span-6-3">
            <div class="form-box">
              <label for="source">{{ 'Source' | translateWF: 'Source' }} *</label>
              <p-dropdown [formControl]="source" [options]="sourceOptions()" optionLabel="label" optionValue="value" styleClass="w-full" [disabled]="true" />
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Exchange Rates Table -->
    <!-- Lazy: the server pages this. The history grows by a row per currency per day, so the table
    must never be handed the whole set to slice client-side. -->
    <p-panel header="Results">
      <p-card data-variant="compact">
        <p-table
          *ngIf="exchangeRates().length > 0"
          [value]="exchangeRates()"
          [lazy]="true"
          (onLazyLoad)="onLazyLoad($any($event))"
          [paginator]="true"
          [rows]="pageSize()"
          [totalRecords]="totalRecords()"
          [loading]="loading()"
          [rowsPerPageOptions]="[10, 25, 50]"
          [responsive]="true"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'Currency' | translateWF: 'Currency' }}</th>
              <th class="text-right">{{ 'Buy_Rate' | translateWF: 'Buy' }} <small class="block font-normal">HNL / 1 USD</small></th>
              <th class="text-right">{{ 'Sell_Rate' | translateWF: 'Sell' }} <small class="block font-normal">HNL / 1 USD</small></th>
              <th class="text-right">{{ 'Average_Rate' | translateWF: 'Average' }} <small class="block font-normal">HNL / 1 USD</small></th>
              <th class="text-right">{{ 'Rate_to_USD' | translateWF: 'Legacy' }} <small class="block font-normal">HNL / 1 USD</small></th>
              <th>{{ 'Financial_Institution' | translateWF: 'Institution' }}</th>
              <th>{{ 'Effective_Date' | translateWF: 'Effective Date' }}</th>
              <th>{{ 'Source' | translateWF: 'Source' }}</th>
              @if (!isReadOnly) {
                <th>{{ 'Actions' | translateWF: 'Actions' }}</th>
              }
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-exchangeRate>
            <tr>
              <td>
                @switch (exchangeRate.currency) {
                  @case (0) {
                    USD
                  }
                  @case (1) {
                    HNL
                  }
                  @default {
                    {{ exchangeRate.currency }}
                  }
                }
              </td>
              <!-- Stored AS HNL per 1 USD (~24.70) — the form people quote. Shown as-is; the reciprocal
                     (~0.04) is the GL's posting multiplier and is never what this screen displays. -->
              <td class="text-right">{{ exchangeRate.buyRateToUSD | number: '1.4-4' }}</td>
              <td class="text-right">{{ exchangeRate.sellRateToUSD | number: '1.4-4' }}</td>
              <td class="text-right">{{ exchangeRate.averageRateToUSD || exchangeRate.rateToUSD | number: '1.4-4' }}</td>
              <td class="text-right">{{ exchangeRate.rateToUSD | number: '1.4-4' }}</td>
              <td>{{ exchangeRate.financialInstitution || '—' }}</td>
              <td>
                {{ exchangeRate.effectiveDate | date: 'dd/MM/yyyy' : 'UTC' }}
              </td>
              <td>
                @switch (exchangeRate.source) {
                  @case (0) {
                    Manual
                  }
                  @case (1) {
                    API
                  }
                  @default {
                    {{ exchangeRate.source }}
                  }
                }
              </td>
              @if (!isReadOnly) {
                <td>
                  <p-button
                    icon="pi pi-pencil"
                    [rounded]="true"
                    [text]="true"
                    [raised]="true"
                    severity="info"
                    (click)="editExchangeRate(exchangeRate)"
                    [pTooltip]="'Edit' | translateWF: 'Edit'"
                  />
                </td>
              }
            </tr>
          </ng-template>
        </p-table>

        @if (exchangeRates().length === 0) {
          <div class="text-center py-8 text-gray-500">
            <p>
              {{
                'No_Exchange_Rates_Found'
                  | translateWF
                    : 'No exchange rates found. Use the search filters or add a new
            exchange rate.'
              }}
            </p>
          </div>
        }
      </p-card>
    </p-panel>
  </div>
</main>
